/* === BEGIN imported: customComponent/whyUs.jsx (verbatim from plugin) === */
import React from "react";
import {hopnLanguageArray} from "@/utils/functions.js";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {
    logoLatest,
    perkReliableIcon,
    perkFlatRateIcon,
    perkCancellationIcon,
    perkHoldFundsIcon,
    perkChildSeatsIcon,
    perkLuggageIcon,
    flightDelayIcon,
    infinityIcon,
} from "@img/index.js";

// The "More Than A Ride. Why Choose Us?" body. Reused both as the standalone
// promo popup (WhyUs, which adds its own header) and rendered directly inside
// .upper-modal overlays (e.g. bookingReceived "More Perks") — mirrors the plugin.
// pillLogo: the plugin-style small green pill logo (booking-received popup);
// default keeps the wide green banner used by the standalone WhyUs popup.
export function WhyUsContent({contentSpacing, pillLogo} = {}) {
    return (
        <div className={`hopn-why-us${contentSpacing ? ' modalPages-spacing pb-10' : ''}`} hopn-data-category="why-us">
                    {pillLogo ? (
                        <>
                            <img
                                className="hopn-why-us-logo"
                                src={logoLatest}
                                alt={hopnLanguageArray("why-us", "hopn-logo-alt", "Hopn Logo")}
                                hopn-data-index="hopn-logo-alt"
                                hopn-data-category="why-us"
                            />
                            <br/><br/>
                        </>
                    ) : (
                        <div className="bg-(--accent-green) rounded-3xl flex items-center justify-center py-8 mb-6">
                            <img
                                src={logoLatest}
                                alt={hopnLanguageArray("why-us", "hopn-logo-alt", "Hopn Logo")}
                                className="brightness-0 h-10"
                                hopn-data-index="hopn-logo-alt"
                                hopn-data-category="why-us"
                            />
                        </div>
                    )}

                    <h3
                        hopn-data-index="why-choose-us-title"
                        hopn-data-category="why-us"
                    >
                        {hopnLanguageArray("why-us", "why-choose-us-title", "More Than A Ride. Why Choose Us?")}
                    </h3>

                    <ul>
                        <li hopn-data-index="guaranteed-reliable" hopn-data-category="why-us">
                        <span>
                            <img
                                src={perkReliableIcon}
                                alt={hopnLanguageArray("why-us", "guaranteed-reliable-alt", "Reliable")}
                                hopn-data-index="guaranteed-reliable-alt"
                                hopn-data-category="why-us"
                            />
                        </span>
                            {hopnLanguageArray("why-us", "guaranteed-reliable", "Guaranteed 20+ years of reliable pickup")}
                        </li>
                        <li hopn-data-index="flat-rate" hopn-data-category="why-us">
                        <span>
                            <img
                                src={perkFlatRateIcon}
                                alt={hopnLanguageArray("why-us", "flat-rate-alt", "Flat Rate")}
                                hopn-data-index="flat-rate-alt"
                                hopn-data-category="why-us"
                            />
                        </span>
                            {hopnLanguageArray("why-us", "flat-rate", "Flat Fixed Rate. No surge or per km per minute charges")}
                        </li>
                        <li hopn-data-index="cancellation" hopn-data-category="why-us">
                        <span>
                            <img
                                src={perkCancellationIcon}
                                alt={hopnLanguageArray("why-us", "cancellation-alt", "Cancellation")}
                                hopn-data-index="cancellation-alt"
                                hopn-data-category="why-us"
                            />
                        </span>
                            {hopnLanguageArray("why-us", "cancellation", "Cancellation & Changes 1 hour before pickup")}
                        </li>
                        <li hopn-data-index="square-hold-funds" hopn-data-category="why-us">
                        <span>
                            <img
                                src={perkHoldFundsIcon}
                                alt={hopnLanguageArray("why-us", "square-hold-funds-alt", "Square Hold Funds")}
                                hopn-data-index="square-hold-funds-alt"
                                hopn-data-category="why-us"
                            />
                        </span>
                            Square hold funds and charge after drop-off
                        </li>
                        <li hopn-data-index="free-child-seats" hopn-data-category="why-us">
                        <span>
                            <img
                                src={perkChildSeatsIcon}
                                alt={hopnLanguageArray("why-us", "free-child-seats-alt", "Free child car seats")}
                                hopn-data-index="free-child-seats-alt"
                                hopn-data-category="why-us"
                            />
                        </span>
                            {hopnLanguageArray("why-us", "free-child-seats", "FREE child car seats")}
                        </li>
                        <li hopn-data-index="luggage-assistance" hopn-data-category="why-us">
                        <span>
                            <img
                                src={perkLuggageIcon}
                                alt={hopnLanguageArray("why-us", "luggage-assistance-alt", "Luggage Assistance")}
                                hopn-data-index="luggage-assistance-alt"
                                hopn-data-category="why-us"
                            />
                        </span>
                            {hopnLanguageArray("why-us", "luggage-assistance", "Luggage assistance")}
                        </li>
                    </ul>

                    <div className="blue-area">
                        <div className="blue-area-inner">
                            <h5 hopn-data-index="flight-delayed-title" hopn-data-category="why-us">
                                {hopnLanguageArray("why-us", "flight-delayed-title", "Flight Delayed? No Problem:")}
                            </h5>
                            <div className="blue-area-inner-tab" hopn-data-index="flight-delayed-desc" hopn-data-category="why-us">
                                <img
                                    src={flightDelayIcon}
                                    alt={hopnLanguageArray("why-us", "flight-delayed-alt", "Flight Delay")}
                                    hopn-data-index="flight-delayed-alt"
                                    hopn-data-category="why-us"
                                />
                                {hopnLanguageArray(
                                    "why-us",
                                    "flight-delayed-desc",
                                    "Hop’n tracks your flight and adjusts your pickup time automatically. Whether it’s a flight delay or baggage hold-up, we’ve got you covered. Simply choose “By flight arrival” and let your captain ensure a smooth pickup experience"
                                )}
                            </div>
                        </div>

                        <div className="blue-area-inner">
                            <h5 hopn-data-index="unlimited-wait-title" hopn-data-category="why-us">
                                {hopnLanguageArray("why-us", "unlimited-wait-title", "Enjoy Unlimited Wait Time:")}
                            </h5>
                            <div className="blue-area-inner-tab" hopn-data-index="unlimited-wait-desc" hopn-data-category="why-us">
                                <img
                                    src={infinityIcon}
                                    alt={hopnLanguageArray("why-us", "unlimited-wait-alt", "Unlimited Wait")}
                                    hopn-data-index="unlimited-wait-alt"
                                    hopn-data-category="why-us"
                                />
                                {hopnLanguageArray(
                                    "why-us",
                                    "unlimited-wait-desc",
                                    "Lost baggage? Customs or immigration delays? No worries—your driver will wait as long as needed"
                                )}
                            </div>
                        </div>
                    </div>
        </div>
    );
}

// Standalone promo popup shell (banner + flight-airport steps): header + scroll
// wrapper around the shared WhyUsContent body.
export function WhyUs(props) {
    return (
        <div className="hopn-modal-container-inner flex flex-col max-h-[95dvh] overflow-hidden" hopn-data-category="why-us">
            <div className="shrink-0">
                <ModalHeader
                    title=""
                    extraClasses=""
                    totalSteps={0}
                    cancelButton={true}
                    cancelButtonType="icon"
                    showBackButton={false}
                    inline={true}
                    setStep={() => {}}
                    closeModal={() => {
                        storage.set(STORAGE_KEYS.HAS_USER_CLOSE_BANNER_POPUP, false);
                        props.setWhyUsPopup(false);
                    }}
                />
            </div>
            <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
                {/* Small green pill logo, matching the plugin and the bookingReceived
                    "More Perks" popup — not the full-width green banner. */}
                <WhyUsContent contentSpacing pillLogo/>
            </div>
        </div>
    );
}
/* === END imported: customComponent/whyUs.jsx === */
